import { motion, useMotionValue } from "framer-motion";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import ProfileCard from "./ProfileCard";

const SPEED = 40;

const AnimatedRow = ({ items, reverse = false }) => {
  const x = useMotionValue(0);
  const trackRef = useRef(null);

  const [width, setWidth] = useState(0);
  const [activeCard, setActiveCard] = useState(false);

  const isDragging = useRef(false);
  const lastX = useRef(0);

  const dir = reverse ? 1 : -1;

  /* Measure width of ONE set */
  useLayoutEffect(() => {
    if (!trackRef.current) return;
    setWidth(trackRef.current.scrollWidth / 2);
  }, [items]);

  /* Infinite flow (depends on activeCard) */
  useEffect(() => {
    if (!width) return;

    let raf;
    let lastTime = performance.now();

    const loop = (now) => {
      const delta = now - lastTime;
      lastTime = now;

      // ONLY MOVE WHEN NO CARD IS ACTIVE
      if (!activeCard && !isDragging.current) {
        let current = x.get();
        current += dir * (delta / 1000) * SPEED;

        if (current <= -width) current += width;
        if (current >= 0) current -= width;

        x.set(current);
      }

      raf = requestAnimationFrame(loop);
    };

    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [width, activeCard, dir]);

  /* Drag only on row */
  const onPointerDown = (e) => {
    lastX.current = e.clientX;
    isDragging.current = false;
  };

  const onPointerMove = (e) => {
    if (e.buttons !== 1 && e.pointerType !== "touch") return;

    const dx = e.clientX - lastX.current;
    if (Math.abs(dx) > 2) isDragging.current = true;

    if (!isDragging.current) return;

    let current = x.get() + dx;
    lastX.current = e.clientX;

    if (current <= -width) current += width;
    if (current >= 0) current -= width;

    x.set(current);
  };

  const onPointerUp = () => {
    isDragging.current = false;
  };

  return (
    <div
      className="overflow-hidden py-8 md:pt-20 cursor-grab active:cursor-grabbing"
      style={{ touchAction: "pan-y" }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerLeave={onPointerUp}
    >
      <motion.div
        ref={trackRef}
        className="flex gap-12 w-max select-none"
        style={{ x }}
      >
        {[...items, ...items].map((item, i) => (
          <ProfileCard
            key={`${item.id}-${i}`}
            specialist={item}
            setActive={setActiveCard}
          />
        ))}
      </motion.div>
    </div>
  );
};

export default AnimatedRow;
